import React, { useEffect } from 'react';
import { Button, CircularProgress, Typography } from '@material-ui/core';

import { useStyles } from './styles';
import { IDeleteModalProps } from './interfaces';
import { Modal } from '../../../../../components/migrated/modal';
import { useEnvironment, useSnackbar } from '../../../../../hooks';
import { useQualityDeleteReturnReceiptGql } from '../../graphql/deleteReturnReceipt';

export const ModalDelete = (props: IDeleteModalProps) => {
  const { open, handleClose, personId, returnReceiptId, updateData } = props;
  const classes = useStyles();
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();

  const { runQualityDeleteReturnReceiptMutation, errorQualityDeleteReturnReceipt, loadingQualityDeleteReturnReceipt } =
    useQualityDeleteReturnReceiptGql();

  useEffect(() => {
    if (errorQualityDeleteReturnReceipt) {
      if (DEBUG === 'TRUE') {
        const msg = errorQualityDeleteReturnReceipt.message;
        console.log(`Erro ao carregar dados! Error:(message: ${msg} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar informações. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorQualityDeleteReturnReceipt]);

  const onDelete = () => {
    runQualityDeleteReturnReceiptMutation({
      variables: { returnReceiptId, personId },
      onCompleted: () => {
        toggleSnackbar({
          message: 'Relatório excluído com sucesso!',
          type: 'success'
        });
        handleClose();
        setTimeout(updateData, 1000);
      }
    });
  };

  return (
    <>
      <Snackbar />
      <Modal
        open={open}
        onClose={handleClose}
        hideClose
        disableBackdropClick
        disableEscapeKeyDown
        title="EXCLUIR REGISTRO DE DEVOLUÇÃO"
      >
        <div className={classes.root}>
          {loadingQualityDeleteReturnReceipt && <CircularProgress />}

          <div style={{ marginTop: '24px' }}>
            {!loadingQualityDeleteReturnReceipt && (
              <Typography>Tem certeza que deseja excluir o registro de devolução?</Typography>
            )}

            {loadingQualityDeleteReturnReceipt && (
              <Typography>Aguarde enquanto as informações são excluídas.</Typography>
            )}
          </div>
          <div className={classes.buttons} style={{ display: `${loadingQualityDeleteReturnReceipt ? 'none' : null}` }}>
            <Button
              variant="text"
              color="primary"
              onClick={onDelete}
              style={{ marginRight: '12px' }}
              disabled={loadingQualityDeleteReturnReceipt}
            >
              Excluir
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              disabled={loadingQualityDeleteReturnReceipt}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
